import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TransactionTable from '../../components/TransactionTable';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../Redux/reducer';
import { setCivilIdAction } from '../../Redux/actions';
import IdleTimerContainer from '../../components/IdleTimerContainer';
import { clearSessionStorage } from '../../services/httpservice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function TransactionDetails() {
    const { t } = useTranslation();
    const [civilId, setLocalCivilId] = useState<string | null>(null);
    const civilIdStore = useSelector((state: RootState) => state.civilId);
    const dispatch = useDispatch();
    const [toastCloseInMs, setToastCloseInMs] = useState<number>(0);
    const [name, setName] = useState<string>('');
    const [nameArabic, setNameArabic] = useState<string>('');
 
    useEffect(() => {
        const name = sessionStorage.getItem('name');
        const nameArabic = sessionStorage.getItem('nameArabic');
        if(name) {
            setName(name);
        }
        if(nameArabic!== null && nameArabic!== "" && nameArabic!== undefined && nameArabic!== "null") {
            if(name!== null && name!== "" && name!== undefined && name!== "null") {
                setName(name +" / ");
            }
            setNameArabic(nameArabic);
        }
        const accessToken = sessionStorage.getItem('accessToken');
        if (!accessToken) {
            clearSessionStorage();
            navigate('/');
            return;
        }

        const storedCivilId = sessionStorage.getItem('civilId');
        if (storedCivilId) {
            setLocalCivilId(storedCivilId);
            dispatch(setCivilIdAction(storedCivilId));
        } else if (civilIdStore) {
            setLocalCivilId(civilIdStore);
        }
    }, [civilIdStore, civilId]);

    useEffect(() => {
        if (civilId) {
            const msToast = process.env.REACT_APP_TOAST_CLOSE_IN_SECONDS;
            if(msToast) {
            setToastCloseInMs(parseInt(msToast));
            }
            sessionStorage.setItem('civilId', civilId);
        }
    }, [civilId]);

    const navigate = useNavigate();
    const refreshPage = () => {
        setLocalCivilId(civilIdStore);
    }
    return (
        <Container className='mainContainer' maxWidth="xl" sx={{ mt: { xs: 24, sm: 4 }, mb: 10, minWidth: "375px" }}>
            <Box >
                <Box className="headerSubheaderStyle headerColor headerBgColor" sx={{ px: 5 }} >
                    <Box className="trns-HeaderTitle pad-right-10" > {t('transactions.transactionDetails')} <br/>   </Box>
                    {/* <Box className="trns-HeaderTitle" sx={{ fontSize: { xs: '0.9rem', sm: '1.2rem' } }}> {name}<span dir="rtl" lang="ar" className='pad-right-10'>{nameArabic}</span> </Box> */}
                    <Box className="civilId"> {t('deals.civilId')}<span dir="rtl" lang="ar"></span> - {civilId} </Box>
                </Box>
              <Box className="trns-subHeader" sx={{ px: 5, display: "flex", flexDirection: "column", gap: 1 }}>

  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    }}
  >
    {/* LEFT */}
    <Box className="trns-subheaderText">
      {t('transactions.transactionsHistory')} <br />
    </Box>

    {/* RIGHT */}
    <Box className="trns-refreshBox">
      <Button
        variant="contained"
        onClick={refreshPage}
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          fontSize: "14px",
          fontWeight: 500,
          padding: "6px 16px",
          "&:hover": { backgroundColor: "#2A92BD", boxShadow: "none" },
        }}
      >
        <RefreshIcon sx={{ fontSize: "18px" }} />
        <span className="refreshText">{t('common.refresh')}</span>
      </Button>
    </Box>
  </Box>

  {/* NOTE */}
<Box className="trns-tableDiv" sx={{ padding: 0 }}>
  <div
    className="text-left  mb-2"
    style={{ textAlign: "start" }}
  >
    <small>
{t('transactions.paymentUpdateNote')}    </small>
  </div>
</Box>

</Box>
                 <Box className='trns-tableDiv' sx={{ padding: { xs: '25px 30px', md: '0px 40px 25px 40px;' } ,   pt: 0, }}>
                    <TransactionTable civilId={civilId} />
                </Box>
                {/* <Box className="trns-backBoxContainer"
                    sx={{ display: { xs: 'none', sm: 'flex', justifyContent: 'space-between' } }}>
                    <Box sx={{ ml: 1 }}>
                        <Link className='trns-backBoxContainerLink' to={`/home/deals`}>
                            BACK
                        </Link>
                    </Box>
                </Box> */}
            </Box>
            <IdleTimerContainer />
            <ToastContainer
          position="top-right"
          newestOnTop
          limit={1}
          autoClose={toastCloseInMs}
        />
        </Container >
        
    )
}

export default TransactionDetails